import React from "react";
import styles from "./Organisationsform.module.css";
import cardStyles from "./Card.module.css";
import { TbTargetArrow } from "react-icons/tb";
import { FaRegHourglassHalf } from "react-icons/fa6";
import { FaCircleCheck } from "react-icons/fa6";
import { FaRegCalendarCheck } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import { GoPerson } from "react-icons/go";
import { LuBookOpenText } from "react-icons/lu";
import { GrVulnerability } from "react-icons/gr";
import { IoDocumentTextOutline } from "react-icons/io5";
import { TbAccessPoint } from "react-icons/tb";

const features = [
    {
        icon:<TbTargetArrow />,
        title: "Zielgruppe",
        content: <div><p>Absolventen</p>
            <p>der Mittleren Reife oder der zweijährigen Berufsfachschule oder gleichwertigem Abschluss</p></div>
    },
    {
        icon: <FaRegCalendarCheck/>,
        title: "Beginn Schulunterricht",
        content:<div><p>10. August 2026</p>
        <p>nach den Sommerferien</p></div>

    },
    {
        icon: <GoPerson />,
        title: <div><h1>Praktikum</h1>
        <h2>11. Klasse (1 Jahr)</h2></div>,
        content: <ul>
            <li>geeigneten Institution</li>
            <li>Betrieb mit Ausbildungsberechtigung</li>
            <li>Einblicke in verschiedene Bereiche</li>
            <li>i.d.R. 8 Std. pro Tag, 3 Wochentage, auch in den Ferien, min. 800 Std., Urlaubsanspruch gemäß gesetzlicher Bestimmungen</li>
            <li>2 Tätigkeitsberichte</li>
            <li>Bescheinigung + ein qualifiziertes Praktikumszeugnis</li>
            <li> In die 12. Klasse versetzt wird nur, wer das Praktikum erfolgreich absolviert hat</li>
        </ul>
    },
    {
        icon:<TbAccessPoint />,
        title: "Berechtigungen",
        content: <ul>
            <li>Zugang zu allen Studiengängen an einer Hochschule</li>
            <li>Zugang zu Bachelor- und Masterstudiengänge (gegliederte Studiengänge) an Universitäten</li>
            <li>Zugang zu mittleren und gehobenen Funktionen in Technik, Wirtschaft und Verwaltung</li>
        </ul>
    },
    {
        icon: <FaRegHourglassHalf />,
        title: "Dauer",
        content: "24 Monate",
    },
    {
        icon: <BsClockHistory />,
        title: "Unterrichtszeiten",
        content: (
            <div>
                <p><span style={{ fontWeight: "500", color:"#3d4666" }}>11. Klasse:</span></p>
                <p>zwei Unterrichtstage die Woche</p>
                <p><span style={{ fontWeight: "500",color:"#3d4666" }}>12. Klasse:</span></p>
                <p>täglich Unterricht</p>
            </div>
        )
    },
    {
        icon:<LuBookOpenText />,
        title: "Schulungsinhalte",
        content: <div>
            <p><span style={{ fontWeight: "500", color:"#3d4666" }}>11. Klasse:</span></p>
            <ul key="list1">
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Beruflicher Pflichtlernbereich:</span> mehrere schwerpunktbezogene Themen- und Aufgabenfelder</li>
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Beruflicher Wahlpflichtbereich:</span> Wirtschaftsenglisch</li>
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Allgemeiner Lernbereich:</span> Deutsch, PoWi, Englisch, Mathe</li>
            </ul>
            <p><br/><span style={{ fontWeight: "500", color:"#3d4666" }}>12. Klasse:</span></p>
            <ul key="list2">
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Beruflicher Pflichtlernbereich:</span> mehrere schwerpunktbezogene Themen- und Aufgabenfelder</li>
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Beruflicher Wahlpflichtbereich:</span> zwei schwerpunktbezogene Themen- und Aufgabenfelder</li>
                <li><span style={{ fontWeight: "500", color:"#5a8271" }}>Allgemeiner Lernbereich:</span> Deutsch, Englisch, Mathematik, Chemie, Physik, Sport, PoWi und Ethik</li>
            </ul>
        </div>,
    },
    {
        icon:<FaCircleCheck />,
        title: "Voraussetzung",
        content:
            <div>
                <p>✔ Versetzungszeugnis in die Einführungsphase der gymnasialen Oberstufe</p>
                <p>✔ mittlere Reife</p>
                <p>✔ Noten:</p>
                <p> Mit mindestens befriedigenden Leistungen in zwei der Fächer Deutsch, Mathematik und Englisch, wobei in keinem der genannten Fächer die Leistungen schlechter als ausreichend sein dürfen</p>
            </div>,
    },
    {
        icon: <GrVulnerability />,
        title: "Zielsetzung",
        content: "Im Mittelpunkt steht die Studier- und Berufsfähigkeit der Schülerinnen und Schüler.",
    },
    {
        icon:<IoDocumentTextOutline />,
        title:"Dokumente zur Anmeldung",
        content: <ul>
            <li>Eignungsfeststellung der abgebenden Schule oder Versetzung in die Gymnasiale Oberstufe</li>
            <li>Berufsberatungs-
                bescheinigung</li>
            <li>Zusage Praktikumspla</li>
            <li> ggf. die letzten 2 Zeugnisse<br/>
                (10/1 und 9/2)</li>
            <li>Lebenslauf</li>
            <li>Impfnachweis</li>
        </ul>
    },

];

const FeaturesCard = ({ features }) => (
    <div className={cardStyles.card}>
        <div className={cardStyles.icon}>{features.icon}</div>
        <div className={cardStyles.title}>{features.title}</div>
        <div className={cardStyles.content}>{features.content}</div>

    </div>
);

const OrganisationsformA = () => {
    return(
        <div>
           <div className="wrapper">
                 <section className="wrapperContent">
                        <div className={styles.text}>
                            <h2>Organisationsform A</h2>
                            <p>In der zweijährigen Organisationsform A findet der erste Ausbildungsabschnitt im Wechsel statt. Die Schülerinnen und Schüler arbeiten an drei Tagen in der Woche im Rahmen eines gelenkten Praktikums in einem Betrieb. An zwei Tagen in der Woche besuchen sie den Unterricht in der Fachoberschule der entsprechenden Fachrichtung oder des entsprechenden Schwerpunktes. Damit wird eine besondere Verzahnung des theoretischen Unterrichts mit der praktischen Ausbildung erzielt. Im zweiten Ausbildungsabschnitt bereiten sich die Schülerinnen und Schüler in Vollzeit auf die Abschlussprüfung zum Erwerb der Fachhochschulreife vor.</p>
                        </div>
                </section>
                 <section className="wrapperContent">
                    <div className={cardStyles.container}>
                        {features.map((features, index) => (
                            <FeaturesCard key={index} features={features} />
                        ))}
                    </div>
                </section>
            </div>
            <div className={styles.container}>
                <div className="wrapperSM wrapperContent">
                    <h2 className={styles.caption}>Die Organisationsform A</h2>
                    <div className="grid">
                        <div className="col-12 lg:col-3">
                            <div className={styles.label}>Aufnahme</div>
                        </div>
                        <div className="col-12 lg:col-9">
                            <div className={styles.content}>
                                Um in der FOS aufgenommen zu werden braucht es einen Realschulabschluss mit mindestens den Noten 3, 3, 4 in den Hauptfächern Deutsch, Englisch, Mathematik oder das Versetzungszeugnis in die gymnasiale Oberstufe. Die Noten aus einer integrierten Gesamtschule werden je nach Kursniveau umgerechnet.
                                Desweiteren sollten vorliegen: eine Eignungsfeststellung der abgebenden Schule, die Zusage zu einem Praktikumsplatz und eine Berufsberatungsbescheinigung.
                            </div>
                        </div>
                        <div className="col-12 lg:col-3">
                            <div className={styles.label}>Unterricht</div>
                        </div>
                        <div className="col-12 lg:col-9">
                            <div className={styles.content}>
                                <p>Auch die Ausbildung in der FOS folgt dem Gedanken des dualen Systems. Allerdings verteilen sich die Gewichte in den zwei Ausbildungsjahren unterschiedlich</p>
                                <p>Im ersten Jahr sind die Schülerinnen und Schüler zwei Wochentage in der Schule, drei Wochentage im Betrieb, am Praktikumsplatz. Das sogenannte gelenkte Praktikum wird zwischen unserer Schule und der Praktikumsstelle schriftlich vereinbart. Es beginnt jeweils am 1. August und dauert bis zum Ende der vorletzten Woche vor den Sommerferien. Der Schüler (Praktikant) hat mindestens zwei Tätigkeitsberichte vorzulegen. Der Betrieb erstellt am Ende ein Zeugnis, das Aussagen über die fachliche Qualifikationen, Präsenz und Leistungsbereitschaft, selbständiges Arbeiten, Teamfähigkeit u.a. macht.An den zwei Schultagen werden die tradionellen Fächer Deutsch, Mathematik, Englisch, Politik und Wirtschaft sowie ein 4-stündiger beruflicher Schwerpunkt unterrichtet.</p>
                                <p>Im zweiten Jahr findet die gesamte Ausbildung in der Schule statt, wobei von den 30-32 Wochenstunden nur noch ein Drittel dem beruflichen Schwerpunkt gewidmet ist.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default OrganisationsformA;

